// Mirrors internal/inbox/intake/imap.InboxHorizonMonths / imap.SentHorizonMonths (adapter.go).
// Pinned both ways: InboxReadsSection.test.tsx reads adapter.go (FE == Go); internal/inbox/intake/imap/horizon_pin_test.go
// asserts the Go values 12/24 and names this file (the frontend CI lane is web/-path-gated, so a Go-only edit is caught
// only by the Go side).
export const INBOX_HORIZON_MONTHS = 12;
export const SENT_HORIZON_MONTHS = 24;
export const IMAP_ADAPTER = 'imap'; // imap.AdapterName
export const DEFAULT_IMAP_PORT = 993;
/** After an ok Disconnect, how long to wait for the best-effort `removed` push before reloading List. */
export const DISCONNECT_REMOVED_WAIT_MS = 30_000;
export const CALL_ADAPTER = 'call'; // call.AdapterName (INBOX-03)
export const TELEGRAM_ADAPTER = 'telegram'; // tgwire.Channel (INBOX-13a)
export const TELEGRAM_CONSENT_VERSION = 'tg-consent-2026-10-22'; // tgwire.ConsentVersion — pinned by boot_telegram_test.go
/** INBOX-13a D31: the connect item polls the link status every 3 s while a step is pending, for at most 15 min. */
export const TELEGRAM_POLL_INTERVAL_MS = 3_000;
export const TELEGRAM_POLL_MAX_MS = 15 * 60_000;
/** Where the always-on screen sends the user back to after a Telegram refusal (D46); same-origin, checked there. */
export const TELEGRAM_RETURN_PATH = '/settings/inbox#inbox-telegram';
